import { render } from "./Title.vue?vue&type=template&id=1fbadb68"
const script = {}

import exportComponent from "/var/www/kuka/4771ba2f/modules/Manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__